import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Card from '../components/ui/Card';

const BlogPostCard = ({ post }) => {
  const [markdownContent, setMarkdownContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMarkdown = async () => {
      try {
        const response = await fetch(post.content);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const text = await response.text();
        setMarkdownContent(text);
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };

    fetchMarkdown();
  }, [post.content]);

  const getFirstWords = (text, numWords) => {
    const words = text.split(/\s+/);
    return words.slice(0, numWords).join(' ') + (words.length > numWords ? '...' : '');
  };

  let summary = '';
  if (!loading && !error && markdownContent) {
    summary = getFirstWords(
      markdownContent
        .replace(/<[^>]+>/g, '') // Remove HTML tags
        .replace(/#{1,6}\s?/g, '') // Remove Markdown headers
        .replace(/\*\*(.*?)\*\*/g, '$1') // Remove bold markdown
        .replace(/\*(.*?)\*/g, '$1') // Remove italic markdown
        .replace(/\[(.*?)\]\(.*?\)/g, '$1') // Remove markdown links
        .replace(/!\[(.*?)\]\((.*?)\)/g, ''), // Remove markdown images
      50
    );
  } else if (error) {
    summary = 'Error loading content.';
  } else {
    summary = 'Loading content...';
  }

  return (
    <Card className="mb-6 flex flex-col md:flex-row-reverse items-start max-w-3xl">
      {post.thumbnail && (
        <div className="md:w-1/3 w-full flex-shrink-0 mb-4 md:mb-0 md:ml-4">
          <Link to={`/blog/${post.slug}`}>
            <img src={post.thumbnail} alt={post.title} className="w-full h-40 object-cover rounded-lg" />
          </Link>
        </div>
      )}
      <div className="flex-grow">
        <Link to={`/blog/${post.slug}`}>
          <h2 className="text-3xl font-bold mb-2 hover:text-teal-600 transition-colors duration-300">{post.title}</h2>
        </Link>
        <p className="text-gray-700 text-m mb-4">{summary}</p>
        <Link to={`/blog/${post.slug}`} className="text-teal-600 hover:underline">
          Read More
        </Link>
      </div>
    </Card>
  );
};

export default BlogPostCard;
